/**
 * Component: sa-work-flow
 * Description: Workflow diagram component
 */
if (!customElements.get('sa-work-flow')) {
  class SaWorkFlow extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('sa-work-flow', SaWorkFlow);
}
